/* eslint-disable react/style-prop-object */
import React from "react";

const OurGoals = () => {
  const content = [
    {
      icon: 'far fa-bullseye-arrow',
      heading: " Mission Statement ",
      para: "Our mission is to bring the authentic flavors and rich culinary traditions of Africa to the heart of Spokane. We provide exceptional barbecue experiences, using fresh, African and locally sourced ingredients.",
    },
  ];
  return (
    <section
      className="mission mt_100 xs_mt_70"
      style={{ background: "url(images/mission_bg.png)" }}
    >
      <div className="mission_overlay pt_70 xs_pt_40 pb_100 xs_pb_70">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-md-10 col-lg-7">
              <div className="mission_text">
                <ul>
                  {content?.map((e, i) => (
                    <li>
                      <div className="icon">
                        <i className={e?.icon} />
                      </div>
                      <div className="text">
                        <h4>{e?.heading}</h4>
                        <p className="fs-5">
                        {e?.para}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurGoals;
